<script>
  import DialogLogin from '@components/Dialog/Login';
  import DialogDealer from '@components/Dialog/Dealer';
  import DialogDealerGroup from '@components/Dialog/DealerGroup';
  import { authComputed } from '@store/helpers'

  export default {
    components: {
      BulletinItem: () => import("@components/List/BulletinItem"),
      NewsItem: () => import("@components/List/NewsItem"),
      DialogLogin,
      DialogDealer,
      DialogDealerGroup,
    },
    props: {
      promotion: {
        type: Array,
        default: () => {
          return []
        },
      },
      bulletin: {
        type: Array,
        default: () => {
          return []
        },
      },
    },
    data() {
      return {
        newsActiveName: 'promotion',
        isDialogLoginVisible: false,
        isDialogDealerVisible: false,
        isDialogDealerGroupVisible: false,
        callbackLogin: () => {
        },
      }
    },
    computed: {
      ...authComputed,
      formattedList() {
        const list = [...this.promotion, ...this.bulletin]
        return list.map((item) => ({
          title: item.title,
          publish_up: item.publish_up,
          description: item.description,
          introimage: item.introimage,
          brands: item.brands[0],
          extrafields: item.extrafields,
          to: {
            name: 'brand-news-item',
            params: {
              brandAlias: this.$route.params.brandAlias,
              categoryAlias: item.category_alias.split('/')[1],
              newsAlias: item.alias,
            },
          },
          isdealer: item.extrafields.dealer_only.value === "1",
          categoryAlias: item.category_alias.split('/')[1],
        }))
      },
    },
    methods: {
      componentName(alias) {
        const map = {
          bulletin: 'BulletinItem',
          promotion: 'NewsItem'
        }
        return map[alias]
      },
      goToView(item) {
        const loggedInFn = () => {
          this.isDialogLoginVisible = false;
          this.$nextTick(() => {
            if(item.isdealer && this.currentMember?.groupId !== 6) {
              this.isDialogDealerGroupVisible = true
            } else {
              this.$router.push(item.to)
            }
          })
        };

        if(this.loggedIn) {
          loggedInFn()
        } else {
          this.callbackLogin = () => {
            loggedInFn()
          };
          this.isDialogDealerVisible = true
        }
      },
      showLogin(val) {
        this.isDialogLoginVisible = val
        this.isDialogDealerVisible = false
      }
    }
  }
</script>

<template>
  <section id="news" class="section">
    <div class="container">
      <BaseSectionTitle title="最新消息" class="text-center"/>
      <div v-if="!!formattedList.length" :class="$style.news" class="row">
        <div v-for="(item, $index) in formattedList" :key="$index" class="col-lg-6 col-12 h-100 formattedListItem">
          <component
            :is="componentName(item.categoryAlias)" 
            content-type="news"
            :item="item"
            :class="{ 'news__item': item.categoryAlias === 'promotion' }"
            custom-class="isStyleBrandHomePage"
            @goTo="goToView"
          />
        </div>
      </div>
      <template v-if="!!formattedList.length">
        <div class="text-center">
          <BaseButton
            class="isStylePrimary isRadius isCol4"
            :to="{ name: 'brand-news-list', params: { categoryAlias: newsActiveName } }"
          >
            查看所有最新消息
          </BaseButton>
        </div>
      </template>
    </div>
    <DialogDealerGroup
      :visible.sync="isDialogDealerGroupVisible"
    />
    <DialogDealer
      :visible.sync="isDialogDealerVisible"
      @isShowlogin="showLogin"
    />
    <DialogLogin
      :visible.sync="isDialogLoginVisible"
      @login="callbackLogin"
    />
  </section>
</template>
<style lang="scss" module>
  .news {
    margin-top: 4rem;
    margin-bottom: 1.75rem;
    :global {
      .formattedListItem {
        margin-bottom: 2rem;
      }
    }
  }
</style>
